(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rating-stars"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateRatings() {
      document.querySelectorAll('.product-card-group[data-review-count]:not([data-ratings-updated])').forEach(group => {
        const avgRating = parseFloat(group.dataset.avgRating) || 0;
        const reviewCount = group.dataset.reviewCount;

        const ratingDiv = group.querySelector('.rating');
        if (!ratingDiv) return;

        group.setAttribute('data-ratings-updated', 'true');

        const countEl = ratingDiv.querySelector('.rating__count');
        if (countEl && reviewCount) {
          countEl.textContent = `(${reviewCount} avis)`;
        }

        if (avgRating > 0) {
          const stars = ratingDiv.querySelectorAll('.rating-star');
          stars.forEach((star, index) => {
            const starNumber = index + 1;
            if (avgRating >= starNumber) {
              star.classList.add('rating-star--filled');
              star.textContent = 'star_rate';
            } else if (avgRating >= starNumber - 0.5) {
              star.classList.add('rating-star--filled');
              star.textContent = 'star_half';
            } else {
              star.classList.remove('rating-star--filled');
              star.textContent = 'star_rate';
            }
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateRatings);
    } else {
      updateRatings();
    }

    new MutationObserver(() => {
      if (document.querySelectorAll('.product-card-group[data-review-count]:not([data-ratings-updated])').length) {
        updateRatings();
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
